<div data-e2e-timeline-control class="timeline-control-container leaflet-control" id="timelineControl">
   <!-- the null check here is included as part of ZTT-1200 if a user goes to asset/assetId/history directly. For some reason,
   dispatching the recent path action was not triggering loading state so skeletons were not properly showing on app init.
   It was easier just to do it this way instead of trying to track down how state was working with loading state -->
   <div
      *ngIf='(locationFacade.getRecentPathLoadState() | async) === loading || (locationFacade.getRecentPathLoadState() | async) === null'
      class='path-skeleton-frame'>
      <div class='skeleton-container' fxLayout='row' fxLayoutAlign='space-between center'>
         <div fxFlex='89'>
            <ngx-skeleton-loader></ngx-skeleton-loader>
         </div>
         <div fxFlex='11'>
            <button mat-raised-button class="view-trip" disabled="true">{{
              translations.map.timelineControl.viewTrips | translate }}</button>

         </div>
      </div>
   </div>
   <div
      *ngIf='(locationFacade.getRecentPathLoadState() | async) === loaded  || (locationFacade.getRecentPathLoadState() | async) === loadFailure'>
      <div *ngIf="points">
         <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="89" class="time-line">
               <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="time-line-bar-container">
                  <div fxFlex="100">
                     <div *ngIf="settings$ | async as settingsValue" class="mb-2">
                       <div *ngIf="settingsValue.elapsedTime" fxLayout="row" fxLayoutAlign="space-between" (mouseleave)="reset()" >
                        <div class="timeline-icon" >
                        <mat-icon class="person">person</mat-icon>
                        </div>
                        <div  *ngFor="let el of points;let index=index; let last=last; let first=first"
                           class="time-line-point mb-4" (mousedown)='mouseDown(el,index)' (mouseup)='mouseUp(index)'>
                           <div class="time-line-bar activity__status--{{el.properties?.driverState | lowercase}} not-selectable"
                              (mouseover)='onHover(el,index)'>
                              <div id={{index}}>
                              </div>
                              <span *ngIf="el.properties?.driverChange" class="driver-change-indicator"></span>
                           </div>
                           <div *ngIf="hoverIndex===index" [ngClass]="{'on-hover': hoverIndex===index}">
                              <span class="glyphs activity__status--{{el.properties?.driverState | lowercase}}">{{
                                 el?.driverStateGyph }}</span>
                           </div>
                        </div>
                        </div>
                     </div>
                     <div fxLayout="row" fxLayoutAlign="space-between" (mouseleave)="reset()">
                        <div class="timeline-icon">
                        <mat-icon>local_shipping</mat-icon>
                        </div>
                        <div *ngFor="let el of points;let index=index; let last=last; let first=first"
                           class="time-line-point" (mousedown)='mouseDown(el,index)' (mouseup)='mouseUp(index)'>
                           <div class="time-line-bar {{el.status}} not-selectable" (mouseover)='onHover(el,index)'>
                              <div id={{index}}>
                              </div>
                           </div>
                           <div *ngIf="hoverIndex===index" [ngStyle]="{background: 'url(' + el.markerSrc + ') '}"
                              [ngClass]="{'on-hover': hoverIndex===index}"></div>
                           <span class="timestamp"
                              [ngClass]="{ 'show-time': this.selectEnable, 'hide-time':!this.selectEnable}"
                              *ngIf="index===this.pointStartZoom">{{startTimeZoom}}</span>
                           <span class="timestamp" *ngIf="!(first ||last ) && hoverIndex===index">{{
                              getLocalizedTimestamp(el.properties.timestamp) }}</span>
                        </div>
                     </div>
                  </div>
                  <div fxFlex="50" class="time start">
                     <span [ngClass]="{ 'show-time': this.showStartTime, 'hide-time':!this.showStartTime }">
                        {{startTimeStamp}} </span>
                  </div>
                  <div fxFlex="50" class="time end">
                     <span [ngClass]="{ 'show-time': this.showEndTime, 'hide-time':!this.showEndTime }">
                        {{endTimeStamp}} </span>
                  </div>
               </div>
            </div>
            <div fxFlex="10"><button mat-raised-button color="accent" class="view-trip" [disabled]="!segmentSelected"
                  (click)="viewEntireTrip()">{{ translations.map.timelineControl.viewTrips
                  | translate }}</button>

            </div>
         </div>
      </div>
   </div>
</div>